module.exports = __webpack_public_path__ + "static/media/en.68355522.svg";